// Mock data for WCOMPass Landing Page

export const mockDemoSubmit = async (formData) => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  console.log('Demo agendada (MOCK):', formData);
  
  return {
    success: true,
    message: 'Demo agendada com sucesso! Entraremos em contato em breve.',
    data: {
      id: Math.random().toString(36).substr(2, 9),
      ...formData,
      createdAt: new Date().toISOString()
    }
  };
};

export const features = [
  {
    id: 1,
    title: "Gestão de Passageiros",
    description: "Cadastros completos de condomínios, blocos, unidades e passageiros com controle centralizado de autorizados",
    icon: "Users"
  },
  {
    id: 2,
    title: "Credenciais NFC",
    description: "Cartões físicos NFC e credenciais virtuais para embarque seguro e rastreável",
    icon: "CreditCard"
  },
  {
    id: 3,
    title: "App do Motorista",
    description: "Validação remota via NFC/Bluetooth com foto do passageiro e alertas visuais e por voz",
    icon: "Smartphone"
  },
  {
    id: 4,
    title: "App do Condômino",
    description: "Consulta de horários, rotas, visualização de ônibus no mapa e credencial virtual",
    icon: "MapPin"
  },
  {
    id: 5,
    title: "Gestão de Frota",
    description: "Controle completo de frotas, rotas, pontos de embarque e otimização operacional",
    icon: "Bus"
  },
  {
    id: 6,
    title: "Relatórios e Dashboards",
    description: "Dados em tempo real, relatórios operacionais e evidências para prestação de contas",
    icon: "BarChart3"
  }
];

export const embarqueFlow = [
  {
    step: 1,
    title: "Credencial NFC/Virtual",
    description: "Passageiro usa cartão físico ou credencial virtual no celular"
  },
  {
    step: 2,
    title: "Leitura NFC",
    description: "Identificação é capturada pelo dispositivo do passageiro"
  },
  {
    step: 3,
    title: "Envio Bluetooth",
    description: "Dados enviados via Bluetooth ao app do motorista"
  },
  {
    step: 4,
    title: "Validação Instantânea",
    description: "App exibe foto e status com confirmação visual e por voz"
  },
  {
    step: 5,
    title: "Registro Automático",
    description: "Embarque validado e registrado automaticamente no sistema"
  }
];

export const painPoints = [
  {
    icon: "AlertTriangle",
    title: "Falhas de Segurança",
    description: "Ausência de controle efetivo de acesso aos veículos"
  },
  {
    icon: "Search",
    title: "Falta de Rastreabilidade",
    description: "Impossibilidade de comprovar embarques e desembarques"
  },
  {
    icon: "DollarSign",
    title: "Custos Ocultos",
    description: "Perdas operacionais não identificadas e custos imprevistos"
  },
  {
    icon: "FileQuestion",
    title: "Sem Evidências",
    description: "Dificuldade em comprovar qualidade do serviço prestado"
  }
];

export const phases = [
  {
    phase: 1,
    duration: "0-30 dias",
    title: "Implantação Inicial",
    items: [
      "Gestão completa de passageiros e credenciais",
      "App do motorista com validação NFC/Bluetooth",
      "Controle de acesso e autorizações",
      "Operação assistida e treinamento"
    ],
    goal: "Estabilizar operação e ganhar confiança"
  },
  {
    phase: 2,
    duration: "Após 30 dias",
    title: "Expansão de Recursos",
    items: [
      "App do condômino completo",
      "Credencial virtual integrada",
      "Georreferenciamento em tempo real",
      "Visualização de veículos no mapa"
    ],
    goal: "Ampliar transparência e valor percebido"
  }
];

export const pricing = [
  {
    item: "Gestão + App motorista + App condômino",
    price: "R$ 350",
    unit: "/ônibus/mês"
  },
  {
    item: "Validação remota NFC (Bluetooth)",
    price: "R$ 100",
    unit: "/ônibus/mês"
  },
  {
    item: "Georreferenciamento",
    price: "R$ 150",
    unit: "/ônibus/mês",
    note: "Cobrado após 30 dias"
  }
];
